import { render, staticRenderFns } from "./drawerProjectsTaskCreateMultiple.vue?vue&type=template&id=8df59d7e&"
import script from "./drawerProjectsTaskCreateMultiple.vue?vue&type=script&lang=js&"
export * from "./drawerProjectsTaskCreateMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports